/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 98);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

// registry of all custom events used in the app. Not ideal abstraction but good
// for sanity without going and reinventing interfaces.

var customEventNames = [
  'dataCurrentTrackInfo',
  'dataNowPlayingInfo',
  'dataShowInfo',
  'dataBroadcastInfo',
  'dataHtmlPage',

  'navigationRequestStarted',
  'navigationRequestProgress',
  'navigationRequestEnded',

  'uiMediaStateChange',
  'uiMainMenuToggled',
  'uiScrollSnap',
  'uiSliderValueChanged',
  'uiUpdateSliderValue',
  'uiDidSearch',
  'uiModalDismiss',
  'uiWantsDonation',
  'uiActivateTab',
  'uiTabActivated',
  'uiWantsPageAudioMetadata',

  // Audio manager events (controls what's going to play)
  'audioWantsPlayback',
  'audioWantsSkip',
  'audioWantsPause',
  'audioWantsStop',
  'audioWantsSetVolume',
  'audioNothingToPlay',
  'audioCueSource',
  'audioClearSource',
  'audioCued',
  'audioFormatNotSupported',

  // Audio source (MP3 stream or archive) events
  'audioSourceLoading',
  'audioSourcePlaying',
  'audioSourcePaused',
  'audioSourceResumed',
  'audioSourceSeekOutOfRange',
  'audioSourceStalled',
  'audioSourceEnded',
  'audioSourceTimeUpdate',
  'audioSourceMetadataUpdate',
  'audioSourceVolumeChanged',

  // Audio metadata defined in pages
  'pageAudioMetadataUpdate',
  'pageAudioMetadataCleared',

  'streamPlay',

  'themeChange',
  'themeWasChanged',

  'donationEnded',
  'donationStarted'
];

var eventRegistry = {};
customEventNames.forEach(function (evName) {
  eventRegistry[evName] = evName;
});

module.exports = eventRegistry;


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* A builder for creating UI Components with className states and discoverability */

function ComponentObjectHelper(component) {
  this.component = component;
}

ComponentObjectHelper.prototype.defineAttributeProperty = function (propName, attrName, validateFunc, afterSetFunc) {
  const element = this.component.element;
  var shadowValue = null;
  var domIsSetting = false;

  Object.defineProperty(this.component, propName, {
    get: function getAttributeProperty() {
      if (shadowValue === null) {
        shadowValue = element.getAttribute(attrName);
      }
      return shadowValue;
    },
    set: function setAttributeProperty(newValue) {
      const finalValue = (typeof validateFunc === 'function') ? validateFunc(newValue) : newValue;

      // Only update if changing
      if (finalValue === shadowValue) { return; }

      shadowValue = finalValue;

      if (!domIsSetting) {
        domIsSetting = true;
        requestAnimationFrame(function () {
          element.setAttribute(attrName, shadowValue);
          domIsSetting = false;
        });
      }

      if (typeof afterSetFunc === 'function') {
        afterSetFunc(shadowValue);
      }
    }
  });
};

ComponentObjectHelper.prototype.defineClassState = function (propName, className, validateFunc, afterSetFunc) {
  const element = this.component.element;
  var shadowValue = null;
  var domIsSetting = false;

  Object.defineProperty(this.component, propName, {
    get: function getState() {
      if (shadowValue === null) {
        shadowValue = element.classList.contains(className);
      }
      return shadowValue;
    },
    set: function setState(truth) {
      const bool = (validateFunc && typeof validateFunc === 'function') ? !!validateFunc(truth) : !!truth;

      if (shadowValue === bool) { return; }

      shadowValue = bool;

      if (!domIsSetting) {
        domIsSetting = true;
        requestAnimationFrame(function () {
          element.classList.toggle(className, shadowValue);
          domIsSetting = false;
        });
      }

      if (typeof afterSetFunc === 'function') {
        afterSetFunc(shadowValue);
      }
    }
  });
};

function forgeUiComponent(className, states, constructFn) {
  if (typeof className !== 'string') {
    throw new TypeError('Component requires a root className');
  }

  constructFn = constructFn || function () {};
  states = states || {};

  if (typeof constructFn !== 'function') {
    throw new TypeError('Component constructor must be a function');
  }

  if (typeof states !== 'object') {
    throw new TypeError('Component states must be an object');
  }

  // Create a constructor for the component we're defining
  function UiComponent(rootElement, options) {
    var self = this;

    if (!rootElement || rootElement.nodeType !== Node.ELEMENT_NODE) {
      throw new TypeError('Component requires an HTMLElement root');
    }

    options = options || {};

    if (typeof options !== 'object') {
      throw new TypeError('Component options must be an object');
    }

    const initAttribute = UiComponent.initAttribute();
    if (rootElement.getAttribute(initAttribute) !== null) {
      throw new Error('Component already initialized');
    } else {
      rootElement.setAttribute(initAttribute, +new Date());
    }

    const componentBuilder = new ComponentObjectHelper(this);

    Object.defineProperty(this, 'element', {
      get: function getRootElement() { return rootElement; }
    });

    Object.defineProperty(this, 'options', {
      get: function getOptions() { return options; }
    });

    Object.keys(states).forEach(function (stateProp) {
      componentBuilder.defineClassState(stateProp, states[stateProp]);
    });

    constructFn.apply(self, [rootElement, options, componentBuilder]);
  }

  UiComponent.prototype.queryProperty = function queryProperty(propName, returnUndefinedIfAbsent) {
    const selector = ['.', className, '-', propName].join('');
    const element = this.element.querySelector(selector);
    if (element) {
      return element;
    } else if (returnUndefinedIfAbsent) {
      return undefined;
    } else {
      return this.element.ownerDocument.createElement('ui-component-property');
    }
  };

  UiComponent.prototype.queryPropertyAll = function queryProperty(propName) {
    const selector = ['.', className, '-', propName].join('');
    return this.element.querySelectorAll(selector);
  };

  UiComponent.prototype.queryPropertyAttribute = function queryProperty(propName, attributeName) {
    var element = this.queryProperty(propName, true);
    if (element) {
      return element.getAttribute(attributeName);
    }
    return null;
  };


  /**
   *
   * @param {String} name The event name
   * @param {Object} detail The CustomEvent detail payload
   * @param {String|Event|HTMLElement} sourceProperty The source of the event (default: component root element)
   * @param {Boolean} bubbles Whether the event bubbles (default: true)
   */
  UiComponent.prototype.dispatchEvent = function dispatchComponentEvent(name, detail, sourceProperty, bubbles) {
    var sourceElement;
    const eventData = {
      detail: detail,
      bubbles: bubbles === undefined ? true : bubbles
    };
    if (!sourceProperty) {
      sourceElement = this.element;
    } else if (sourceProperty instanceof Event) {
      sourceElement = sourceProperty.target;
    } else if (sourceProperty instanceof HTMLElement) {
      sourceElement = sourceProperty;
    } else {
      sourceElement = this.queryProperty(sourceProperty);
    }
    if (!sourceElement) {
      return;
    }
    sourceElement.dispatchEvent(new CustomEvent(name, eventData));
  };

  UiComponent.initAttribute = function initAttribute() {
    return ['data', 'component', className.toLowerCase(), 'initialized'].join('-');
  };

  UiComponent.discover = function discoverComponent(rootElement, options) {
    var components = [];
    var errors = [];

    rootElement = rootElement || document.body;
    options = options || {};

    if (!rootElement || rootElement.nodeType !== Node.ELEMENT_NODE) {
      throw new TypeError('Components can only be discovered inside of DOM Elements');
    }

    if (typeof options !== 'object') {
      throw new TypeError('Component options must be an object');
    }

    if (rootElement.classList.contains(className)) {
      try {
        components += new UiComponent(rootElement, options);
      } catch (e) {
        errors += e;
      }
    } else {
      Array.prototype.forEach.call(rootElement.getElementsByClassName(className), function (discoveredElement) {
        try {
          components += new UiComponent(discoveredElement, options);
        } catch (e) {
          errors += e;
        }
      });
    }

    return {
      components: components,
      errors: errors
    };
  };

  return UiComponent;
}

module.exports = forgeUiComponent;


/***/ }),

/***/ 12:
/***/ (function(module, exports) {

/** Verify required functions for the app are available */
function checkCompat() {
  const testElement = document.createElement('DIV');
  const requiredFeatures = [
    document.dispatchEvent,
    testElement.classList,
    testElement.closest,
    window.Audio,
    window.CustomEvent,
    window.requestAnimationFrame
  ];
  const j = requiredFeatures.length;
  var i = 0;

  for (; i < j; i += 1) {
    if (typeof requiredFeatures[i] === 'undefined') {
      return false;
    }
  }
  return true;
}

module.exports = checkCompat;


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

/** Broadcast Metadata
  * Pull broadcast data from the API and emit metadata updates when appropriate
  */
const events = __webpack_require__(0);
const broadcastApi = __webpack_require__(17);

function BroadcastMetadata(mp3url, broadcastId) {
  var self = this;

  if (!broadcastId) {
    return;
  }

  Object.defineProperty(this, 'id', {
    get: function () { return broadcastId; }
  });

  Object.defineProperty(this, 'src', {
    get: function () { return mp3url; }
  });

  this.playlist = [];

  document.addEventListener(events.dataBroadcastInfo, function (e) {
    self.parseBroadcast(e.detail);
  });

  document.addEventListener(events.audioSourceTimeUpdate, function (e) {
    const audioSrc = e.detail && e.detail.src;

    if (audioSrc !== mp3url) { return; }

    // TODO: Probably throttle this
    self.handleTrackProgress(e.detail.time);
  });

  if (broadcastId) {
    broadcastApi.fetch(broadcastId);
  }
}

// Handle data — store show core data
// Structure tracks with normalized timestamps for file duration
BroadcastMetadata.prototype.parseBroadcast = function parseBroadcast(data) {
  var self = this;
  this.title = data.title;
  this.showName = data.Show.title;
  this.showUrl = data.url; // Link to the broadcast page
  this.showImageUrl = data.Show.Image.url_md;

  const showStartTime = this.makeTimestamp(data.start);

  this.playlist = data.tracks.map(function mapTrack(track) {
    return {
      id: track.id,
      start: self.makeTimestamp(track.played) - showStartTime,
      // Guard against < 0 end times
      end: Math.max(0, track.ended ? self.makeTimestamp(track.ended) - showStartTime : Infinity) || Infinity,
      artist: track.artist,
      title: track.title,
      album: track.album,
      label: track.label
    };
  });

  // Trigger an initial update as the data has arrived
  this.handleTrackProgress(0);
};

BroadcastMetadata.prototype.makeTimestamp = function makeTimestamp(creekDate) {
  return Date.parse(creekDate.split(' ').join('T')) / 1000;
};

BroadcastMetadata.prototype.trackForTime = function trackForTime(ms) {
  return this.playlist.filter(function (track) {
    return track.start <= ms && track.end > ms;
  }).pop();
};

BroadcastMetadata.prototype.handleTrackProgress = function handleTrackProgress(time) {
  // Do nothing if there's no data yet
  if (!this.title) { return; }

  const currentTrack = this.trackForTime(time) || { id: -1 };

  if (this.lastNotifiedTrack === currentTrack.id) { return; }

  const metadataUpdate = {
    src: this.src,
    metadata: {
      title: currentTrack.title || this.title,
      artist: currentTrack.artist,
      show: this.showName,
      showUrl: this.showUrl,
      image: this.showImageUrl,
      isStream: false
    }
  };

  document.dispatchEvent(new CustomEvent(events.audioSourceMetadataUpdate,
    { bubbles: true, detail: metadataUpdate })
  );

  this.lastNotifiedTrack = currentTrack.id;
};

module.exports = BroadcastMetadata;


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

/** Static Playback Metadata
  * Return static/predefined playback metadata for media files
  */
const events = __webpack_require__(0);

function StaticPlaybackMetadata(mp3url, metadata) {
  var self = this;

  if (!metadata) {
    return;
  }

  Object.defineProperty(this, 'metadata', {
    get: function () { return metadata; }
  });

  Object.defineProperty(this, 'src', {
    get: function () { return mp3url; }
  });

  document.addEventListener(events.audioSourceTimeUpdate, function (e) {
    const audioSrc = e.detail && e.detail.src;

    // If the audio src is unchanged since the last update, discard since metadata is static
    if (this.lastSrc === audioSrc) { return; }

    // If the audio src is not this MP3, disregard the event
    if (audioSrc !== mp3url) { return; }

    self.handleTrackProgress();
    this.lastSrc = audioSrc;
  });
}

StaticPlaybackMetadata.prototype.handleTrackProgress = function handleTrackProgress() {
  const metadataUpdate = {
    src: this.src,
    metadata: {
      title: this.metadata.title,
      artist: this.metadata.artist,
      show: this.metadata.show,
      showUrl: this.metadata.showUrl,
      image: this.metadata.image,
      isStream: false
    }
  };

  document.dispatchEvent(new CustomEvent(events.audioSourceMetadataUpdate,
    { bubbles: true, detail: metadataUpdate })
  );
};

module.exports = StaticPlaybackMetadata;


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

/* Fetch data from Creek /tracks API */

const events = __webpack_require__(0);
const fetch = __webpack_require__(5);

const broadcastUrlBase = '/api/broadcast/';

// Broadcasts never change when re-run so we cache the responses;
var broadcastCache = {};

const broadcasts = {
  fetch: function fetchBroadcast(id) {
    if (Object.prototype.hasOwnProperty.call(broadcastCache, id)) {
      document.dispatchEvent(new CustomEvent(events.dataBroadcastInfo, {
        detail: broadcastCache[id]
      }));
      return;
    }

    const broadcastUrl = broadcastUrlBase + id;
    fetch.get(broadcastUrl, { responseType: 'json' }, {
      success: function gotShow(response) {
        broadcastCache[id] = response;
        document.dispatchEvent(new CustomEvent(events.dataBroadcastInfo, {
          detail: response
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  }
};

module.exports = broadcasts;


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

/** Autoplay
  * Listen for 'nothingToPlay' and 'playbackEnded' events, trigger stream playback
  */
const events = __webpack_require__(0);

function Autoplay() {
  document.addEventListener(events.audioNothingToPlay, function () {
    document.dispatchEvent(new CustomEvent(events.streamPlay));
  });

  document.addEventListener(events.audioSourceEnded, function () {
    document.dispatchEvent(new CustomEvent(events.streamPlay));
  });
}

module.exports = Autoplay;


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

/* global MediaMetadata */
const events = __webpack_require__(0);
const FALLBACK_IMAGE = 'https://aw.bff.fm/assets/favicons/apple-touch-icon/670e7f66554fa4d50219e02bee256e233047dc1e.png';

/**
 * MediaSessionHandler provides an interface between the BFF audio metadata updates and the browser
 * navigator.mediaSession API for displaying track info in Android lock screen notifications.
 */
function MediaSessionHandler() {
  const self = this;
  var nowPlaying;

  Object.defineProperty(this, 'nowPlaying', {
    get: function () { return nowPlaying; },
    set: function (newSource) {
      if (newSource === nowPlaying) {
        return;
      }
      if (!newSource) {
        nowPlaying = false;
      } else {
        nowPlaying = newSource;
      }
      this.clear();
    }
  });

  if ('mediaSession' in window.navigator) {
    // Track what is currently playing using loading and timeupdate:
    document.addEventListener(events.audioSourceLoading, function (e) {
      self.nowPlaying = e.detail && e.detail.src;
    });

    document.addEventListener(events.audioSourceTimeUpdate, function (e) {
      self.nowPlaying = e.detail && e.detail.src;
    });

    // Receive metadata and filter for now playing:
    document.addEventListener(events.audioSourceMetadataUpdate, function (e) {
      const audioSource = e.detail && e.detail.src;
      if (audioSource !== nowPlaying) {
        return;
      }
      self.updateMetadata(e.detail.metadata);
    });
  }
}

MediaSessionHandler.prototype.updateMetadata = function updateMetadata(metadata) {
  if (!metadata.title || metadata.title === metadata.show) {
    // Show metadata
    navigator.mediaSession.metadata = new MediaMetadata({
      title: metadata.show,
      artist: metadata.artist,
      album: 'BFF.fm',
      artwork: [{ src: metadata.image || FALLBACK_IMAGE }]
    });
  } else {
    navigator.mediaSession.metadata = new MediaMetadata({
      title: metadata.title,
      artist: metadata.artist,
      album: [metadata.show, 'on BFF.fm'].join(' '),
      artwork: [{ src: metadata.image || FALLBACK_IMAGE }]
    });
  }
};

MediaSessionHandler.prototype.clear = function clearMetadata() {
  navigator.mediaSession.metadata = new MediaMetadata({
    title: 'BFF.fm',
    artwork: [{ src: FALLBACK_IMAGE }]
  });
};

module.exports = MediaSessionHandler;


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

/* The jukebox. Controls what's playing */

const events = __webpack_require__(0);
const AudioSource = __webpack_require__(89);

function Jukebox() {
  var self = this;
  var onDeck;
  var maintainedVolume = 1.0;

  Object.defineProperty(this, 'currentAudioSource', {
    get: function getCurrentAudioSource() { return onDeck; },
    set: function setAudioSource(audio) {
      if (onDeck === audio) { return; }

      if (onDeck) {
        // TODO: Fade Out
        onDeck.pollingForMetadata = false;
        onDeck.pause();
        // TODO: Does AudioSource need a `destroy`?
      }

      onDeck = audio;

      if (audio) {
        document.dispatchEvent(new CustomEvent(events.audioCued, {
          detail: {
            id: onDeck.id,
            src: onDeck.src
          }
        }));
      } else {
        document.dispatchEvent(new CustomEvent(events.audioClearSource));
      }
    }
  });

  Object.defineProperty(this, 'maintainedVolume', {
    get: function getMaintainedVolume() { return maintainedVolume; }
  });

  document.addEventListener(events.audioCueSource, function (e) {
    const requestedUrl = e.detail && e.detail;

    // Cue (but don't immediately play) new source
    if (requestedUrl) {
      self.cue(e.detail);
    }
  });

  document.addEventListener(events.audioWantsPlayback, function (e) {
    const requestedUrl = e.detail && e.detail.url;

    // Play new source
    if (requestedUrl && (!self.currentAudioSource || self.currentAudioSource.src !== requestedUrl)) {
      self.cue(e.detail);
    }

    // Resume existng source
    if (self.currentAudioSource) {
      self.currentAudioSource.play();
      return;
    }

    // Have no source
    document.dispatchEvent(new CustomEvent(events.audioNothingToPlay));
  });

  document.addEventListener(events.audioWantsPause, function () {
    if (self.currentAudioSource) {
      self.currentAudioSource.pause();
    }
  });

  document.addEventListener(events.audioWantsSkip, function (e) {
    if (self.currentAudioSource && e.detail) {
      if (e.detail.relative) {
        self.currentAudioSource.skip(e.detail.relative);
        return;
      }
      if (e.detail.absolute) {
        self.currentAudioSource.seek(e.detail.absolute);
      }
    }
  });

  document.addEventListener(events.audioSourceVolumeChanged, function (e) {
    maintainedVolume = (e.detail && e.detail.newValue) || maintainedVolume;
  });

  document.addEventListener(events.audioWantsSetVolume, function (e) {
    if (self.currentAudioSource && e.detail) {
      maintainedVolume = e.detail.newValue;
      self.currentAudioSource.volume = maintainedVolume;
    }
  });
}

Jukebox.prototype.cue = function cue(trackData) {
  const url = trackData.url || false;

  // TODO: Validate audio info
  this.currentAudioSource = new AudioSource(url, this.maintainedVolume);
};

module.exports = Jukebox;


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

/** Stream */
const events = __webpack_require__(0);
const nowPlaying = __webpack_require__(93);
const bffConfig = __webpack_require__(9);

const METADATA_REFRESH_RATE = (60 / 4) * 1000;

function LiveStreamProvider(cue) {
  const self = this;
  const streamEventPayload = {
    url: bffConfig.liveStreamUrl,
    metadata: {}
  };

  document.addEventListener(events.streamPlay, function () {
    document.dispatchEvent(new CustomEvent(events.audioWantsPlayback, {
      detail: streamEventPayload
    }));
  });

  if (cue) {
    document.dispatchEvent(new CustomEvent(events.audioCueSource, {
      detail: streamEventPayload
    }));
  }

  document.addEventListener(events.dataNowPlayingInfo, function (e) {
    self.handleMetadata(e.detail);
  });

  document.addEventListener(events.audioFormatNotSupported, function () {
    // TODO: Redirect to “How to Listen” page
  });

  this.refreshMetadata();
  setInterval(function metadataInterval() {
    self.refreshMetadata();
  }, METADATA_REFRESH_RATE);
}

LiveStreamProvider.prototype.refreshMetadata = function refreshMetadata() {
  nowPlaying.fetchCurrent();
};

LiveStreamProvider.prototype.handleMetadata = function handleMetadata(metadata) {
  // Do nothing if there's no data
  if (!metadata || !metadata.title) { return; }

  const metadataUpdate = {
    src: bffConfig.liveStreamUrl,
    metadata: {
      title: metadata.title,
      artist: metadata.attribution,
      show: metadata.show,
      showUrl: metadata.showUrl,
      image: metadata.image,
      isStream: true
    }
  };

  document.dispatchEvent(new CustomEvent(events.audioSourceMetadataUpdate,
    { bubbles: true, detail: metadataUpdate })
  );
};

module.exports = LiveStreamProvider;


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

function request(url, options, callbacks) {
  var xhr;
  var success = callbacks.success || function () {};
  var failure = callbacks.failure || function () {};
  var abort = callbacks.abort || callbacks.failure || function () {};
  var progress = callbacks.progress || function () {};

  if (!options.method) {
    failure();
    return false;
  }

  if (!window.XMLHttpRequest) {
    failure();
    return false;
  }

  xhr = new window.XMLHttpRequest();
  xhr.withCredentials = !!options.withCredentials;

  xhr.addEventListener('progress', function (e) {
    if (e.lengthComputable) {
      progress(e.loaded / e.total, xhr);
    } else {
      progress(-1, xhr);
    }
  });

  xhr.addEventListener('error', function (e) {
    failure(e, xhr);
  });
  xhr.addEventListener('abort', function (e) {
    abort(e, xhr);
  });
  xhr.addEventListener('load', function () {
    success(xhr.response, xhr);
  });

  xhr.open(options.method, url, true);

  if (options.headers) {
    Object.keys(options.headers).forEach(function (k) {
      xhr.setRequestHeader(k, options.headers[k]);
    });
  }

  // TODO: Make this explicit getHtml/getJson methods I think
  xhr.responseType = options.responseType || 'document';
  xhr.send();
  return xhr;
}

function get(url, options, callbacks) {
  var fullOptions = options;
  fullOptions.method = 'GET';
  return request(url, fullOptions, callbacks);
}

function head(url, options, callbacks) {
  var fullOptions = options;
  fullOptions.method = 'HEAD';
  return request(url, fullOptions, callbacks);
}

module.exports = {
  request: request,
  get: get,
  head: head
};


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

var AdvancedPlaybackControls = forgeUiComponent('AdvancedPlaybackControls', {
  paused: 'is-paused',
  streamingLive: 'is-streamingLive',
  playingArchive: 'is-playingArchive'
}, function AdvancedPlaybackControlsConstructor() {
  var self = this;

  document.addEventListener(events.audioSourcePlaying, function (e) {
    if (e.detail.duration === Infinity) {
      self.setPlaybackState(AdvancedPlaybackControls.STREAMING);
    } else {
      self.setPlaybackState(AdvancedPlaybackControls.ARCHIVE);
    }
  });

  document.addEventListener(events.audioSourceTimeUpdate, function (e) {
    if (e.detail.duration === Infinity) {
      self.setPlaybackState(AdvancedPlaybackControls.STREAMING);
    } else {
      self.setPlaybackState(AdvancedPlaybackControls.ARCHIVE);
    }
  });
});

AdvancedPlaybackControls.prototype.setPlaybackState = function setPlaybackState(state) {
  if (state === AdvancedPlaybackControls.ARCHIVE) {
    this.playingArchive = true;
    this.paused = false;
    this.streamingLive = false;
    return;
  }

  if (state === AdvancedPlaybackControls.STREAMING) {
    this.streamingLive = true;
    this.paused = false;
    this.playingArchive = false;
    return;
  }

  this.playingArchive = false;
  this.streamingLive = false;
  this.paused = true;
};

AdvancedPlaybackControls.ARCHIVE = 1;
AdvancedPlaybackControls.STREAMING = 2;
AdvancedPlaybackControls.PAUSED = 3;

module.exports = AdvancedPlaybackControls;


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const MAX_ATTRIBUTE = 'max';
const MIN_ATTRIBUTE = 'min';
const TIMESTAMP_REGEX = /^(?:(\d+)[h:])?(?:(\d+)[m:'′])?(\d+)(?:[s"″])?$/;

var AudioSkipButton = forgeUiComponent('AudioSkipButton', {}, function AudioSkipButtonConstructor() {
  var self = this;
  var currentTime = '0\'00"';

  this.element.addEventListener('click', function (e) {
    var skipValue;

    if (self.fixedConfiguration) {
      skipValue = self.skipAdjustment;
    } else {
      const currentMinutes = currentTime > 0 ? Math.floor(currentTime / 60) : 0;
      const prefilledStamp = currentMinutes + '\'' + Math.floor(currentTime - (currentMinutes * 60)) + '"';
      /* eslint-disable no-alert */
      skipValue = self.parseSkipAdjustment(prompt('Skip to…', prefilledStamp));
      /* eslint-enable no-alert */
    }

    if (skipValue === undefined) {
      return;
    }

    document.dispatchEvent(new CustomEvent(events.audioWantsSkip, {
      detail: skipValue
    }));

    e.preventDefault();
  });

  document.addEventListener(events.audioSourceTimeUpdate, function (e) {
    if (!e || !e.detail) {
      return;
    }

    if (e.detail.duration) {
      currentTime = e.detail.time;
    } else {
      currentTime = 0;
    }
  });

  Object.defineProperty(this, 'fixedConfiguration', {
    get: function hasConfigurationAttribute() {
      return !!this.element.getAttribute('data-skip');
    }
  });

  Object.defineProperty(this, 'skipAdjustment', {
    get: function getSkipAmount() {
      return this.parseSkipAdjustment(this.element.getAttribute('data-skip'));
    }
  });
});

AudioSkipButton.prototype.parseSkipAdjustment = function parseSkipAdjustment(input) {
  if (input === undefined) { return; }

  const configValue = '' + input;

  if (configValue.toLowerCase() === MAX_ATTRIBUTE) {
    return { relative: Infinity };
  }

  if (configValue.toLowerCase() === MIN_ATTRIBUTE) {
    return { relative: -Infinity };
  }

  if (configValue.indexOf('+') === 0 || configValue.indexOf('-') === 0) {
    return { relative: +configValue };
  }

  // Absolute seconds just return
  if (!isNaN(configValue)) {
    return { absolute: +configValue };
  }

  // Timestamp string
  // We'll allow hour:min:sec, min'sec'', min′sec″
  const timeMatch = configValue.match(TIMESTAMP_REGEX);

  if (timeMatch === null) { return; }

  const hours = +(timeMatch[1] || 0);
  const minutes = +(timeMatch[2] || 0);
  const seconds = +(timeMatch[3] || 0);
  const total = seconds + (minutes * 60) + (hours * 60 * 60);

  if (total <= 0) { return; }

  return { absolute: total };
};

module.exports = AudioSkipButton;


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

var MusicPlayer = forgeUiComponent('MusicPlayer', {
  locked: 'is-locked',
  missingImage: 'is-missingImage',
  volumeFocused: 'is-volumeFocused'
}, function MusicPlayerConstructor(rootElement, opts, builder) {
  var self = this;
  var trackId;
  var volumeLimit = 11;
  var lastPageUrl;
  var didRecentlyStop = false;

  Object.defineProperty(this, 'trackId', {
    get: function getTrackId() { return trackId; },
    set: function setTrackId(newId) { trackId = newId; }
  });

  Object.defineProperty(this, 'volumeLimit', {
    get: function getVolumeLimit() { return volumeLimit; },
    set: function setVolumeLimit(updatedLimit) { volumeLimit = updatedLimit; }
  });

  Object.defineProperty(this, 'lastPageUrl', {
    get: function getLastPage() { return lastPageUrl; },
    set: function setLastPage(updatedUrl) { lastPageUrl = updatedUrl; }
  });

  builder.defineClassState('playing', 'is-playing', function validate(bool) {
    return !!bool;
  }, function afterSet(newValue) {
    /* To ensure we ignore delayed progress events, catch if playback ceases */
    if (newValue === false) {
      didRecentlyStop = true;
      setTimeout(function () {
        didRecentlyStop = false;
      }, 500);
    }
  });

  builder.defineAttributeProperty('playFocus', 'data-focus', function validate(target) {
    if (['page', 'archive', 'live'].includes(target)) {
      return target;
    } else {
      return 'live';
    }
  });

  // Listen for sub-component events
  // play button
  // // Dispatch WantsPlayback
  // // Dispatch WantsPause
  // volume slider
  // // Dispatch WantsVolume

  // Listen to audio subsystem events for updates
  // We then emit state events that sub-components like the
  // ProgressPlayButton listen to

  document.addEventListener(events.audioCued, function (e) {
    if (self.locked || !e.detail) { return; }

    self.trackId = e.detail.id;
  });

  document.addEventListener(events.audioSourceLoading, function (e) {
    if (self.trackId !== (e.detail && e.detail.id)) { return; }

    self.playFocus = e.detail.isStream ? 'live' : 'archive';

    self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
      bubbles: true,
      detail: {
        mediaState: 'loading'
      }
    }));
  });

  document.addEventListener(events.audioSourcePlaying, function (e) {
    if (self.trackId !== (e.detail && e.detail.id)) { return; }

    self.playing = true;
    self.playFocus = e.detail.isStream ? 'live' : 'archive';

    self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
      bubbles: true,
      detail: {
        mediaState: 'playing',
        duration: e.detail.duration || Infinity,
        progress: e.detail.duration ? e.detail.time || 0 : Infinity
      }
    }));
  });

  document.addEventListener(events.audioSourceTimeUpdate, function (e) {
    // Ignore buffered time updates after audio is stopped
    if (didRecentlyStop) {
      return;
    }

    if (self.trackId !== (e.detail && e.detail.id)) { return; }

    self.playing = true;
    self.playFocus = e.detail.isStream ? 'live' : 'archive';

    self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
      bubbles: true,
      detail: {
        mediaState: 'progress',
        duration: e.detail.duration || Infinity,
        progress: e.detail.duration ? e.detail.time || 0 : Infinity
      }
    }));
  });

  document.addEventListener(events.audioSourcePaused, function (e) {
    if (self.trackId !== (e.detail && e.detail.id)) { return; }

    self.playing = false;

    self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
      bubbles: true,
      detail: {
        mediaState: 'paused'
      }
    }));
  });

  document.addEventListener(events.audioSourceEnded, function (e) {
    if (self.trackId !== (e.detail && e.detail.id)) { return; }

    self.playing = false;
    self.playFocus = 'live';

    self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
      bubbles: true,
      detail: {
        mediaState: 'paused'
      }
    }));
  });

  document.addEventListener(events.audioSourceResumed, function (e) {
    if (self.trackId !== (e.detail && e.detail.id)) { return; }

    self.playing = true;
    self.playFocus = e.detail.isStream ? 'live' : 'archive';

    self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
      bubbles: true,
      detail: {
        mediaState: 'playing',
        duration: e.detail.duration || Infinity,
        time: e.detail.time || 0
      }
    }));
  });

  // Listen for navigation changes for page content
  // Toggle toggling to the page audio preview mode
  document.addEventListener(events.pageAudioMetadataUpdate, function (e) {
    var detail = e.detail && e.detail;
    if (!detail) {
      return;
    }
    self.possiblyShowPageTrack();
  });

  document.addEventListener(events.pageAudioMetadataCleared, function (e) {
    self.clearPageTrack();
  });

  // TODO: Not yet sure how to handle this event. Need to determine what happens
  //   after a track is `unstalled` in terms of how that would be reflected in UI
  // document.addEventListener(events.audioSourceStalled, function (e) {
  //   if (self.trackId !== (e.detail && e.detail.id)) { return; }

  //   self.element.dispatchEvent(new CustomEvent(events.uiMediaStateChange, {
  //     bubbles: true,
  //     detail: {
  //       mediaState: 'loading'
  //     }
  //   }));
  // });

  document.addEventListener(events.audioSourceVolumeChanged, function (e) {
    const newVolume = (e.detail && e.detail.newValue) || 0;
    const spinalTappedVolume = newVolume * self.volumeLimit;
    // Turn it up to (a percentage of) 11

    self.element.dispatchEvent(new CustomEvent(events.uiUpdateSliderValue, {
      bubbles: true,
      detail: { newValue: spinalTappedVolume }
    }));
  });

  self.element.addEventListener(events.uiSliderValueChanged, function (e) {
    const sliderValue = e.detail && e.detail.newValue;
    self.volumeLimit = (e.detail && e.detail.limit) || 11;

    if (sliderValue === false) { return; }

    self.element.dispatchEvent(new CustomEvent(events.audioWantsSetVolume, {
      bubbles: true,
      detail: { newValue: sliderValue / self.volumeLimit }
    }));
  });

  const volumeIcon = self.element.querySelector('.MusicPlayer-volumeLabel') || document.createElement('a');
  volumeIcon.addEventListener('click', function toggleVolume(e) {
    e.preventDefault();
    self.volumeFocused = !self.volumeFocused;
  });

  // Once we're initialized, ask if there's any page audio
  setTimeout(function () {
    self.dispatchEvent(events.uiWantsPageAudioMetadata);
  }, 10);
});

MusicPlayer.prototype.possiblyShowPageTrack = function possiblyShowPageTrack() {
  // If we're doing anything with an archive, playing or paused don't displace it
  // Otherwise, if we're playing a live-stream, don't replace it
  if (this.playFocus == 'archive' || this.playing) {
    return;
  }
  this.playFocus = 'page';
}

MusicPlayer.prototype.clearPageTrack = function clearPageTrack() {
  // Reset to 'live' if 'page' is the current state (this check prevents resetting
  // to live over other play modes)
  if (this.playFocus == 'page') {
    this.playFocus = 'live';
  }
}

module.exports = MusicPlayer;


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Derived from https://github.com/bendrucker/document-ready

module.exports = function ready(callback) {
  var state = document.readyState;
  if (state === 'complete' || state === 'interactive') {
    return setTimeout(callback, 0);
  }

  document.addEventListener('DOMContentLoaded', function onLoad() {
    callback();
  });
};


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

const bffConfig = __webpack_require__(9);
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);
const BroadcastMetadata = __webpack_require__(15);
const StaticPlaybackMetadata = __webpack_require__(16);

/* Common underpinning component for simple playback buttons and links, handles
 * common state clases. Strictly non-visual on its own. */
var PlaybackInvoker = forgeUiComponent('PlaybackInvoker', {}, function PlaybackInvokerConstructor(element, opts, builder) {
  var self = this;
  var metadataHandler;
  var didRecentlyStop = false;

  builder.defineClassState('loading', 'is-loading');
  builder.defineClassState('playing', 'is-playing', null, function afterSet(newValue) {
    /* To ensure we ignore delayed progress events, catch if playback ceases */
    if (newValue === false) {
      didRecentlyStop = true;
      setTimeout(function () {
        didRecentlyStop = false;
      }, 1000);
    }
  });

  Object.defineProperty(this, 'src', {
    get: function getSrc() {
      // Support base64 encoded src by default
      var src = this.element.getAttribute('data-src');
      if (src) {
        try {
          src = atob(src);
        }
        catch (e) {}
        return src;
      } else {
        return this.element.href;
      }
    }
  });

  Object.defineProperty(this, 'broadcast', {
    get: function getTrackId() {
      return this.element.getAttribute('data-broadcast');
    }
  });

  Object.defineProperty(this, 'caption', {
    get: function getPlayerCaption() {
      return this.element.getAttribute('data-caption');
    }
  });

  Object.defineProperty(this, 'artist', {
    get: function getPlayerCaption() {
      return this.element.getAttribute('data-artist');
    }
  });

  Object.defineProperty(this, 'show', {
    get: function getPlayerShowName() {
      return this.element.getAttribute('data-show');
    }
  });

  Object.defineProperty(this, 'showUrl', {
    get: function getPlayerShowUrl() {
      return this.element.getAttribute('data-showUrl');
    }
  });

  Object.defineProperty(this, 'imageUrl', {
    get: function getPlayerMediaImage() {
      return this.element.getAttribute('data-image');
    }
  });

  Object.defineProperty(this, 'isStream', {
    get: function getStreamAttribute() {
      return !!this.element.getAttribute('data-stream');
    }
  });

  element.addEventListener('click', function (e) {
    e.preventDefault();

    if (self.playing) {
      document.dispatchEvent(new CustomEvent(events.audioWantsPause));
      return;
    }

    const playbackEventPayload = {
      url: self.isStream ? bffConfig.liveStreamUrl : self.src,
      metadata: {} // TODO: Get core/audio out of the metadata business
    };

    document.dispatchEvent(new CustomEvent(events.audioWantsPlayback, {
      detail: playbackEventPayload
    }));

    if (!metadataHandler && self.broadcast) {
      metadataHandler = new BroadcastMetadata(self.src, self.broadcast);
    }

    if (!metadataHandler && self.caption) {
      metadataHandler = new StaticPlaybackMetadata(self.src, {
        title: self.caption,
        artist: self.artist,
        show: self.show,
        showUrl: self.showUrl,
        image: self.imageUrl
      });
    }
  });

  document.addEventListener(events.audioSourceLoading, function handleLoading(e) {
    self.playing = false;
    self.loading = self.eventMatchesPlayer(e);
  });

  document.addEventListener(events.audioSourcePlaying, function handlePlaying(e) {
    self.loading = false;
    self.playing = self.eventMatchesPlayer(e);
  });

  /* By subscribing to TimeUpdate as well as playing, we will update state on
   * content loaded after audio is already playing */
  document.addEventListener(events.audioSourceTimeUpdate, function handlePlaying(e) {
    /* An update event can still be triggered after the pause/end event so we track it */
    if (didRecentlyStop) {
      return;
    }
    self.loading = false;
    self.playing = self.eventMatchesPlayer(e);
  });

  document.addEventListener(events.audioSourceResumed, function handleResume(e) {
    self.playing = self.eventMatchesPlayer(e);
    self.loading = false;
  });

  document.addEventListener(events.audioSourcePaused, function handlePause() {
    self.playing = false;
    self.loading = false;
  });

  document.addEventListener(events.audioSourceEnded, function handleEnded() {
    self.playing = false;
    self.loading = false;
  });
});

PlaybackInvoker.prototype.eventMatchesPlayer = function eventMatchesPlayer(event) {
  return event.detail && ((event.detail.isStream === true && this.isStream === true) || event.detail.src === this.src);
};

module.exports = PlaybackInvoker;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);

var PlayerMenu = forgeUiComponent('PlayerMenu', {
  menuShowing: 'is-showingMenu'
}, function PlayerMenuConstructor() {
  var self = this;

  const button = this.element.querySelector('.PlayerMenu-button') || document.createElement('a');

  button.addEventListener('click', function (e) {
    self.menuShowing = !self.menuShowing;
    e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    if (self.element === e.target || self.element.contains(e.target)) {
      return;
    }

    self.menuShowing = false;
  });
});

module.exports = PlayerMenu;


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const SEEK_ANIMATION_TIME = 1000;

var ProgressPlayButton = forgeUiComponent('ProgressPlayButton', {}, function ProgressPlayButtonConstructor(rootElement, opts, builder) {
  var self = this;
  var unsetSeekingTimeout;
  var lastPlaybackPosition = 0;

  const playButtonElement = this.element.querySelector('.ProgressPlayButton-playButton') || document.createElement('button');
  const pauseButtonElement = this.element.querySelector('.ProgressPlayButton-pauseButton') || document.createElement('button');

  builder.defineClassState('playing', 'is-playing', function validate(isPlaying) {
    if (isPlaying) {
      self.loading = false;
      self.streaming = false;
      self.paused = false;
    }
    return isPlaying;
  });

  builder.defineClassState('progressing', 'is-progressing');
  builder.defineClassState('seeking', 'is-seeking');

  function animateSeek() {
    self.seeking = true;
    clearTimeout(unsetSeekingTimeout);
    unsetSeekingTimeout = setTimeout(function () { self.seeking = false; }, SEEK_ANIMATION_TIME);
  }

  builder.defineClassState('streaming', 'is-streaming', function validate(isStreaming) {
    if (isStreaming) {
      self.loading = false;
      self.playing = false;
      self.paused = false;
      self.progressing = false;
    }
    return isStreaming;
  });

  builder.defineClassState('loading', 'is-loading', function validate(isLoading) {
    if (isLoading) {
      self.playing = false;
      self.streaming = false;
      self.paused = false;
      self.progressing = false;
    }
    return isLoading;
  });

  builder.defineClassState('paused', 'is-paused', function validate(isPaused) {
    if (isPaused) {
      self.playing = false;
      self.streaming = false;
      self.loading = false;
    }
    return isPaused;
  });

  builder.defineAttributeProperty('playbackPercentage', 'data-playback-percentage', function validate(percent) {
    const newValue = isNaN(percent) ? 0 : Math.round(percent);

    if (Math.abs(newValue - lastPlaybackPosition) > 1) {
      animateSeek();
    }

    return newValue;
  }, function afterSet(newValue) {
    self.playbackHalf = newValue >= 50;
  });

  setInterval(function detectSkip() {
    lastPlaybackPosition = self.playbackPercentage;
  }, 2000);

  builder.defineAttributeProperty('playbackHalf', 'data-playback-half', function validate(bool) {
    return bool ? 'true' : 'false';
  });

  // Listen for UI events
  document.addEventListener(events.uiMediaStateChange, function (e) {
    // If state change for an ancestor of this component?
    if (!e.target.contains(self.element)) {
      return;
    }

    // What is the new state?
    if (!e.detail) {
      return;
    }

    switch (e.detail.mediaState) {
      case 'loading': self.loading = true; break;
      case 'paused': self.paused = true; break;
      case 'playing':
        if (e.detail.duration === Infinity) {
          self.streaming = true;
        } else {
          self.play(e.detail.duration, e.detail.progress);
        }
        break;
      case 'progress':
        self.progress(e.detail.duration, e.detail.progress);
        break;
      default:
        // TODO: Should we unset everything or ignore?
        self.loading = false;
        self.playing = false;
        self.streaming = false;
        self.paused = false;
        self.progressing = false;
        self.seeking = false;
    }
  });

  playButtonElement.addEventListener('click', function clickPlay() {
    self.loading = true;
    self.element.dispatchEvent(new CustomEvent(events.audioWantsPlayback, {
      bubbles: true
    }));
  });

  pauseButtonElement.addEventListener('click', function clickPause() {
    self.element.dispatchEvent(new CustomEvent(events.audioWantsPause, {
      bubbles: true
    }));
    self.paused = true;
  });
});

ProgressPlayButton.prototype.play = function play(recordingLength, startPos) {
  this.playing = true;
  this.progress(recordingLength, startPos);
};

ProgressPlayButton.prototype.progress = function play(recordingLength, startPos) {
  if (recordingLength === Infinity) {
    this.progressing = false;
  } else {
    this.progressing = true;
    this.playbackPercentage = (startPos / recordingLength) * 100;
  }
};

ProgressPlayButton.prototype.pause = function pause() {
  this.paused = true;
};

module.exports = ProgressPlayButton;


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

/* Slider */
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

var Slider = forgeUiComponent('Slider', {
  disabled: 'is-disabled'
}, function SliderConstructor() {
  var self = this;

  var fillElement = this.element.querySelector('.Slider-fill') || document.createElement('div');
  var upButton = this.element.querySelector('.Slider-up') || document.createElement('button');
  var downButton = this.element.querySelector('.Slider-down') || document.createElement('button');

  Object.defineProperty(this, 'value', {
    get: function getValue() { return +this.element.getAttribute('data-value') || 0; },
    set: function setValue(v) {
      var newValue = Math.max(0, Math.min(v, this.limit));

      if (newValue === this.value) { return; }

      this.element.setAttribute('data-value', newValue);
      this.element.dispatchEvent(new CustomEvent(events.uiSliderValueChanged, {
        bubbles: true, detail: { newValue: newValue }
      }));
    }
  });

  Object.defineProperty(this, 'limit', {
    get: function getLimit() { return +this.element.getAttribute('data-limit') || 10; },
    set: function setLimit(v) { this.element.setAttribute('data-limit', v); }
  });

  Object.defineProperty(this, 'fillElement', {
    get: function getLimit() { return fillElement; }
  });

  upButton.addEventListener('click', function () {
    self.value += 1;
  });

  downButton.addEventListener('click', function () {
    self.value -= 1;
  });

  self.element.addEventListener(events.uiSliderValueChanged, function () {
    self.recalculateFill();
  });

  // Listen for UI events
  // TODO: Swapping to a generic `updateComponentValue` with a `tag` for the component
  //   could be a useful way to allow for subcomponent updates.
  document.addEventListener(events.uiUpdateSliderValue, function (e) {
    // If state change for an ancestor of this component?
    if (!e.target.contains(self.element)) {
      return;
    }

    // What is the new state?
    if (!e.detail) { return; }

    self.value = e.detail.newValue;
  });

  this.recalculateFill();

  // Emit a volume set event for whatever the slider was first set to
  this.element.dispatchEvent(new CustomEvent(events.uiSliderValueChanged, {
    bubbles: true, detail: { newValue: this.value }
  }));
});

Slider.prototype.recalculateFill = function recalculateFill() {
  const self = this;
  const newWidth = Math.round((this.value / this.limit) * 100);
  requestAnimationFrame(function () {
    self.fillElement.style.width = newWidth + '%';
  });
};

module.exports = Slider;


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

/** Event-driven HTML5 single-stream audio playback
  *
  * Allows audio to be triggered from anywhere in a page, with context provided,
  * and publishes UI events for other components to consume.
  */
const events = __webpack_require__(0);
const throttledDispath = __webpack_require__(94);
/* HACK: Not using HLS yet so don't bundle dep.
const Hls = require('hls.js/dist/hls.light');
// HACK: Only use NATIVE_HLS if hls.js isn't supported. Android Chrome doesn't handle Audio HLS
const NATIVE_HLS = !Hls.isSupported() && !!new Audio().canPlayType('application/vnd.apple.mpegurl');
*/
const STREAM_FILE_REGEX = /^https:\/\/(wwwcdn|stream)\.bff\.fm/; // HACK: const STREAM_FILE_REGEX = /\.m3u8$/;

/*
 * @param src URL An MP3 file to be played
 * @param volume number The initial volume for the track
 *
 * NB “isStream” is treated as a global — e.g. if this AudioSource believes it is a stream
 *    and not a standalone, finite track, it will poll for live metadata from Creek.
 */
function AudioSource(src, volume) {
  const self = this;
  var audioElement;
  var maintainedVolume;

  Object.defineProperty(this, 'id', {
    get: function () { return src.replace(/\W/g, ''); }
  });

  Object.defineProperty(this, 'src', {
    get: function () { return src; }
  });

  Object.defineProperty(this, 'isStream', {
    get: function () { return STREAM_FILE_REGEX.test(src); }
  });

  // hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
  // When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS
  // manifest (i.e. .m3u8 URL) directly to the video element throught the `src` property.
  const hlsHelper = undefined; /* HACK: Not using HLS yet:
    this.isStream && !NATIVE_HLS && Hls.isSupported() ? new Hls({
    autoStartLoad: true,
    liveDurationInfinity: true,
    debug: true }) : undefined;
  */

  Object.defineProperty(this, 'audioElement', {
    get: function () {
      if (!audioElement) {
        this.audioElement = this.src;
      }
      return audioElement;
    },
    set: function (url) {
      if (url === null) {
        if (hlsHelper) {
          hlsHelper.detachMedia();
          hlsHelper.stopLoad();
        } else {
          // TODO: Determine which browsers need this to stop loading?
          audioElement.src = '';
        }
        audioElement = null;
        return;
      }

      audioElement = new Audio();
      audioElement.autoplay = false;
      audioElement.preload = 'metadata';
      audioElement.volume = this.volume;
      audioElement.title = 'BFF.fm'; // Initial title for iOS lock screen

      this.bindAudioEvents(audioElement);
      // TODO: Handle error case when audio cannot be played at all

      if (hlsHelper) {
        // If not native HLS (not Safari or Edge):
        hlsHelper.attachMedia(audioElement);
        hlsHelper.loadSource(url);
      } else {
        // Otherwise, throw the URL to the <audio> element like any other
        audioElement.src = [
          url,
          // HACK: Include cacheBust to workaround Firefox repeating-audio issue with streams
          this.isStream ? '?_cacheBust=' + Math.floor(Math.random() * 50000) : ''
        ].join('');
      }
    }
  });

  Object.defineProperty(this, 'volume', {
    get: function () { return maintainedVolume; },
    set: function (newVolume) {
      var limited = Math.max(0, Math.min(newVolume, 1));

      if (limited === maintainedVolume) { return; }

      maintainedVolume = limited;
      if (audioElement) { audioElement.volume = maintainedVolume; }

      document.dispatchEvent(new CustomEvent(events.audioSourceVolumeChanged, {
        detail: { newValue: maintainedVolume }
      }));
    }
  });

  Object.defineProperty(this, 'baseEventDetail', {
    get: function () {
      return {
        id: this.id,
        src: this.src,
        time: (audioElement && audioElement.currentTime) || 0,
        duration: this.isStream ? Infinity : ((audioElement && audioElement.duration) || Infinity),
        isStream: this.isStream
      };
    }
  });

  // Return a position (in seconds) for this file, depicting the end position of the file when seeking
  Object.defineProperty(this, 'maxPosition', {
    get: function () {
      if (audioElement.duration !== Infinity) {
        return audioElement.duration;
      }
      const buffers = audioElement.buffered.length;
      return audioElement.buffered.end(buffers - 1);
    }
  });

  Object.defineProperty(this, 'playing', {
    get: function () { return audioElement && !audioElement.paused; }
  });

  /* <audio>.title is used by iOS to display playback info on the lock screen */
  Object.defineProperty(this, 'title', {
    get: function getPlaybackTitle() { return (audioElement && audioElement.title) || ''; },
    set: function setPlaybackTitle(str) {
      if (audioElement) {
        if (this.title === str) {
          return;
        }
        audioElement.title = str;

        // HACK: Force iOS to update metadata?
        if (!audioElement.paused) {
          audioElement.play();
        }
      }
    }
  });

  document.addEventListener(events.audioSourceMetadataUpdate, function audioMetadataUpdated(e) {
    if (!audioElement) {
      return;
    }
    if (!e.detail) {
      return;
    }

    if (self.isStream && STREAM_FILE_REGEX.test(e.detail.src)) {
      self.updateMetadata(e.detail.metadata);
    }

    if (audioElement.src === e.detail.src) {
      self.updateMetadata(e.detail.metadata);
    }
  });

  // Set input data
  this.volume = volume;
}

AudioSource.prototype.updateMetadata = function updateTrackMetadata(metadata) {
  // If no unique track info
  var stringParts = [];

  if (!metadata.title || metadata.title === metadata.show) {
    stringParts = [metadata.album, metadata.show, 'BFF.fm'];
  } else {
    stringParts = [metadata.title, metadata.artist, metadata.show, 'BFF.fm'];
  }

  this.title = stringParts.filter(function (item) { return !!item; }).join(' - ');
  return this.title;
  // TODO: Find out if there's a way to set the art from `metadata.image`
};

AudioSource.prototype.play = function play() {
  document.dispatchEvent(new CustomEvent(events.audioSourceLoading, {
    detail: this.baseEventDetail
  }));
  this.audioElement.play();
};

AudioSource.prototype.pause = function pause() {
  if (!this.playing) {
    return;
  }

  this.audioElement.pause();

  if (this.isStream) {
    // HACK: If it's a stream, null out the player to stop background buffering
    this.audioElement = null;
  }
};

AudioSource.prototype.seek = function seek(timestamp) {
  if (isNaN(timestamp)) {
    return;
  }

  const jumpTo = Math.max(0, Math.min(timestamp, this.maxPosition));
  this.audioElement.currentTime = jumpTo;
};

AudioSource.prototype.skip = function skip(amount) {
  if (isNaN(amount)) {
    return;
  }
  this.seek(this.audioElement.currentTime + amount);
};

AudioSource.prototype.bindAudioEvents = function bindAudioEvents(audioElement) {
  var self = this;
  // Simplified event model for AudioSource

  // 1. audioSourceLoading
  // 2. audioSourcePlaying
  // 2a. audioSourceTimeUpdate
  // 2b. audioSourceMetadataUpdate
  // 3. audioSourcePaused
  // 4. audioSourceResumed
  // 5. audioSourceStalled
  // 6. audioSourceEnded

  // We don't care about the file loading
  // audioElement.addEventListener('loadstart', function () {});

  audioElement.addEventListener('playing', function () {
    document.dispatchEvent(new CustomEvent(events.audioSourcePlaying, {
      detail: self.baseEventDetail
    }));
  });
  audioElement.addEventListener('pause', function () {
    document.dispatchEvent(new CustomEvent(events.audioSourcePaused, {
      detail: self.baseEventDetail
    }));
  });
  audioElement.addEventListener('stalled', function () {
    document.dispatchEvent(new CustomEvent(events.audioSourceStalled, {
      detail: self.baseEventDetail
    }));
  });
  audioElement.addEventListener('ended', function () {
    document.dispatchEvent(new CustomEvent(events.audioSourceEnded, {
      detail: self.baseEventDetail
    }));
  });

  audioElement.addEventListener('timeupdate', function () {
    const throttleKey = self.id + events.audioSourceTimeUpdate;
    throttledDispath(throttleKey, new CustomEvent(events.audioSourceTimeUpdate, {
      detail: self.baseEventDetail
    }));
  });

  audioElement.addEventListener('abort', function () {
    document.dispatchEvent(new CustomEvent(events.audioSourcePaused, {
      detail: self.baseEventDetail
    }));
  });

  // TODO: Unsure if these should get echoed out of this object or just handled by the manager
  audioElement.addEventListener('error', function (e) {
    // console.log('error', e);
  });

  audioElement.addEventListener('volumechange', function () {
    self.volume = self.audioElement.volume;
  });
};

module.exports = AudioSource;


/***/ }),

/***/ 9:
/***/ (function(module, exports) {


const config = {
  liveStreamUrl: 'https://stream.bff.fm/1/mp3.mp3'
};

module.exports = config;


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

/* Fetch data from Creek /tracks API */

const events = __webpack_require__(0);
const fetch = __webpack_require__(5);

const showUrlBase = '/api/show/';
const broadcastingUrl = '/api/broadcasting/';

// Shows don't change often, certainly not during a browser session, so we cache
// the responses;
var showCache = {};

const shows = {
  fetch: function fetchShow(id) {
    if (Object.prototype.hasOwnProperty.call(showCache, id)) {
      document.dispatchEvent(new CustomEvent(events.dataShowInfo, {
        detail: showCache[id]
      }));
      return;
    }

    const showUrl = showUrlBase + id;
    fetch.get(showUrl, { responseType: 'json' }, {
      success: function gotShow(response) {
        showCache[id] = response;
        document.dispatchEvent(new CustomEvent(events.dataShowInfo, {
          detail: response
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  },

  fetchCurrent: function fetchCurrent() {
    if (this.currentShowFromCache()) {
      return;
    }

    fetch.get(broadcastingUrl, { responseType: 'json' }, {
      success: function gotShow(response) {
        // HACK: Creek API may return `null` when no track is playing
        if (!response) { return; }

        // TODO: response.upcoming has invalid dates, so ignore
        [response.now, response.next].forEach(function (showData) {
          showCache[showData.id] = showData;
        });

        shows.fetch(response.now.id);
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  },

  currentShowFromCache: function currentShowFromCache() {
    const now = new Date();
    const currentShowId = Object.keys(showCache).filter(function (id) {
      const show = showCache[id];
      if (!show || !show.Airtime) { return false; }

      const start = new Date(show.Airtime.start_date_time_gmt.replace(' ', 'T') + 'Z');
      const end = new Date(show.Airtime.end_date_time_gmt.replace(' ', 'T') + 'Z');

      return now >= start && now <= end;
    }).shift();

    if (!currentShowId) { return false; }

    this.fetch(currentShowId);
    return true;
  }
};

module.exports = shows;


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

/* Fetch data from Creek /tracks API */

const events = __webpack_require__(0);
const fetch = __webpack_require__(5);

const currentTrackUrl = '/api/tracks/current';

const tracks = {
  fetchCurrent: function fetchCurrent() {
    fetch.get(currentTrackUrl, { responseType: 'json' }, {
      success: function gotCurrentTrack(response) {
        document.dispatchEvent(new CustomEvent(events.dataCurrentTrackInfo, {
          detail: response
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  }
};

module.exports = tracks;


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const tracksApi = __webpack_require__(91);
const showsApi = __webpack_require__(90);

function NowPlaying() {
  var self = this;
  this.pendingTrack = undefined;
  this.lastEmittedMetadata = undefined;

  document.addEventListener(events.dataCurrentTrackInfo, function (e) {
    self.receiveTrackInfo(e.detail);
  });

  document.addEventListener(events.dataShowInfo, function (e) {
    self.receiveShowInfo(e.detail);
  });
}

NowPlaying.prototype.receiveTrackInfo = function receiveTrackInfo(data) {
  this.pendingTrack = data;
  // showsApi handles caching of show objects!
  if (data && data.show_id) {
    showsApi.fetch(data.show_id);
  } else {
    showsApi.fetchCurrent();
  }
};

NowPlaying.prototype.receiveShowInfo = function receiveShowInfo(data) {
  if (this.pendingTrack || this.pendingTrack === null) {
    this.possiblyEmitEvent(data, this.pendingTrack);
    this.pendingTrack = undefined;
  }
};

NowPlaying.prototype.possiblyEmitEvent = function possiblyEmitEvent(show, track) {
  const metadata = this.assembleMetadata(show, track);
  const metadataHash = this.metadataHash(metadata);

  // TODO: If empty, or already emitted this combo, return
  if (!metadataHash || metadataHash === this.lastEmittedMetadata) {
    return;
  }

  this.emitEvent(metadata);
};

NowPlaying.prototype.metadataHash = function metadataHash(data) {
  if (!data || data === {}) {
    return false;
  }

  return [data.title, data.show].join(':');
};

NowPlaying.prototype.assembleMetadata = function assembleMetadata(show, track) {
  const optionalTrack = track || {};

  if (!show || !show.title) { return null; }

  return {
    title: optionalTrack.title || show.title,
    attribution:
      optionalTrack.artist || (show.hosts.length > 0 ?
        ['with', show.hosts.map(function (host) { return host.display_name; }).join(' & ')].join(' ')
        : ''),
    // TODO: Make generic by getting station name from a config somewhere
    album: optionalTrack.album || 'BFF.FM',
    label: optionalTrack.label,
    link: optionalTrack.link || show.url,
    show: show.title,
    showUrl: show.url,
    image: (show.Image && show.Image.url) || undefined
  };
};

NowPlaying.prototype.emitEvent = function emitEvent(metadata) {
  document.dispatchEvent(new CustomEvent(events.dataNowPlayingInfo, { bubbles: false, detail: metadata }));
};

NowPlaying.prototype.interface = {
  fetchCurrent: function getNowPlaying() {
    tracksApi.fetchCurrent();
  }
};

module.exports = new NowPlaying().interface;


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

const throttle = __webpack_require__(132);
var events = {};

// Throttle event dispatch (e.g. for audio timeupdate).
// @param key key String Identifier for the throttle; control permutations of
//    the event throttle (e.g. you may limit not by type of event, but by source
//    object, as you please.)
// @param event CustomEvent Event object to be passed to dispatchEvent if this
//    call is executed.
// @param target Element The DOM element from which the event should be triggered.
//    (default window.document)
// @param freq Int The frequency in milliseconds that the event should fire
//    (default 250)
function handleThrottledDispatch(key, event, target, freq) {
  if (!key || !event) {
    return;
  }

  if (typeof events[key] !== 'function') {
    events[key] = throttle(function throttledDispatchEvent(e, t) {
      (t || document).dispatchEvent(e);
    }, freq || 250);
  }

  events[key](event, target);
}

module.exports = handleThrottledDispatch;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

var compatibility = __webpack_require__(12);

var events = __webpack_require__(0);
var domReady = __webpack_require__(7);

var Jukebox = __webpack_require__(46);
var Autoplay = __webpack_require__(43);
var LiveStream = __webpack_require__(47);
var BrowserMediaSession = __webpack_require__(44);

var MusicPlayer = __webpack_require__(69);
var ProgressPlayButton = __webpack_require__(77);
var Slider = __webpack_require__(83);
var PlayerMenu = __webpack_require__(74);
var PlaybackInvoker = __webpack_require__(73);
var AudioSkipButton = __webpack_require__(55);
var AdvancedPlaybackControls = __webpack_require__(54);

// Init Components
function initGlobalComponents() {
  const body = document.body;
  Slider.discover(body);
  ProgressPlayButton.discover(body);
  MusicPlayer.discover(body);
  PlayerMenu.discover(body);
  AdvancedPlaybackControls.discover(body);

  // Init Audio
  new Jukebox();

  // Enable continuous playback
  new Autoplay();

  // Enable Media Session support on Android
  new BrowserMediaSession();

  // Cue up live tracking:
  new LiveStream('cue');
}

function initContentComponents() {
  var body = document.body;
  PlaybackInvoker.discover(body);
  AudioSkipButton.discover(body);
}

// Don't initialize app if browsing is missing features
if (compatibility()) {
  // TODO: Add “discover” to UI components.
  domReady(function () {
    initGlobalComponents();
    initContentComponents();
  });

  document.addEventListener(events.navigationRequestEnded, function (e) {
    if (e.detail.didNavigate) {
      initContentComponents();
    }
  });
}


/***/ })

/******/ });


// WEBPACK FOOTER //
// player.bundle.js